import Immutable from 'immutable';
export var defaults = {
  _highlightResult: undefined,
  addonId: undefined,
  addonKey: undefined,
  releaseDate: undefined,
  name: undefined,
  tagLine: undefined,
  categories: undefined,
  deployments: undefined,
  documentType: undefined,
  logo: undefined,
  vendor: undefined,
  distribution: undefined,
  version: undefined,
  ratings: undefined,
  marketingLabels: undefined,
  programs: undefined
};
export default Immutable.Record(defaults);